import { ImageViewerModal } from '@/components/ImageViewer/ImageViewerModal.tsx';
import { TrashIcon } from '@heroicons/react/24/outline';
import { AssetData } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';
import { useState } from 'react';

interface IImagesList {
  images?: AssetData[];
  onDeleteImageClick?: (image: AssetData) => void;
}
export const ImagesList = ({ images, onDeleteImageClick }: IImagesList) => {
  const [openImageViewerModal, setOpenImageViewerModal] = useState(false);
  return (
    <div className="flex flex-col gap-4">
      <ImageViewerModal
        images={images || []}
        open={openImageViewerModal}
        onClose={() => setOpenImageViewerModal(false)}
      />
      {images?.length ? (
        <div className="flex flex-row flex-wrap gap-4">
          {images?.map((image) => (
            <div key={image.id} className="group/img relative">
              <img
                alt={''}
                src={image.url}
                className="center h-16 w-16 cursor-pointer rounded-md object-contain"
                onClick={() => setOpenImageViewerModal(true)}
              />
              {onDeleteImageClick ? (
                <div className="pointer-events-none invisible absolute top-0 flex h-full w-full items-start justify-end group-hover/img:visible">
                  <Button
                    size="sm"
                    color="negative"
                    onClick={() => onDeleteImageClick(image)}
                    className="pointer-events-auto absolute -top-2 -right-2"
                  >
                    <TrashIcon className="h-4 w-4" />
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-base-500 font-inter text-sm/[1]">No images</div>
      )}
    </div>
  );
};
